<script>
    export let gift;

    $: isPro = gift.pricingPlan === 1;
</script>

{#if gift?.recipient}
    <div class="sent-gift-wrapper">
        <div class="sent-gift">
            {#if isPro}
                <svg
                    class="sent-gift__icon"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"
                    />
                </svg>
            {:else}
                <svg
                    class="sent-gift__icon"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                    />
                </svg>
            {/if}

            <span class="sent-gift__text">
                {gift.recipient.username}
            </span>

            <button class="sent-gift__button">
                {#if gift.redeemed}
                    {isPro ? "Redeemed" : "Activated"}
                {:else if gift.expired}
                    Canceled
                {:else}
                    Sent
                {/if}
            </button>
        </div>
    </div>
{/if}

<style>
    @import "../../../../main.css";

    .sent-gift-wrapper {
        @apply reset flex w-full flex-col items-stretch !important;
    }
    .sent-gift {
        @apply reset flex h-12 flex-row items-center gap-2 rounded-full border border-solid border-gray-300 bg-gray-100 py-2 pl-4 pr-2 text-gray-300 !important;
    }
    .sent-gift__text {
        @apply reset text-sm text-gray-500 !important;
    }
    .sent-gift__button {
        @apply reset ml-auto h-8 min-w-fit cursor-default select-none rounded-full bg-gray-200 px-4 py-1 text-xs tracking-tight text-gray-500 !important;
    }
    .sent-gift__button__bold {
        @apply reset text-xs font-bold tracking-tight text-inherit !important;
    }
    .sent-gift__icon {
        @apply reset h-5 w-5 min-w-fit text-gray-500 !important;
    }
    .sent-gift-message {
        @apply reset mt-1 text-center text-xs text-gray-300 hover:text-black !important;
    }
    .sent-gift-message__bold {
        @apply reset text-xs font-bold text-inherit !important;
    }
</style>
